import { StackedProgressBarController } from './stacked-progress-bar.controller'

function stackedProgressBar () {
  return {
    restrict: 'E',
    scope: {
      stacks: '=',
      total: '<'
    },
    templateUrl: '/core/directives/stacked-progress-bar/stacked-progress-bar.html?$$REVISION$$',
    controller: StackedProgressBarController
  }
}
export { stackedProgressBar }
